
const showBenefitsImageAndQuote = number => {
    // show the desired image/quote & hide all the others
    const benefitsImages = document.getElementsByClassName('benefits-change-images');
    // const quotes = document.getElementsByClassName('small-benefits__top-quote-inner');

    // console.log("showing benefits image and quote section", number);

    Array.from(benefitsImages).forEach((image, index) => {
        image.style.display = $(image).hasClass('image-'+number) ? 'block' : 'none';
        // quotes.item(index).style.display = $(quotes.item(index)).hasClass('quote-'+number) ? 'block' : 'none';
    });
} 

const setTimeline = () => {

    const centerViewportPosition = window.innerHeight/2;
    const anchors = document.getElementsByClassName('benefits-section-anchor');
    const anchorHeaders = document.getElementsByClassName('benefits-item');
    const line = document.getElementsByClassName('benefits-section-follower-line').item(0);
    const benefitsImage = document.getElementsByClassName('benefits-change-images').item(0);

    const anchorPositions = [];

    // get the x-y positions of each of the anchors
    Array.from(anchors).forEach((anchor, index) => {
        const position = anchor.getBoundingClientRect();
        anchorPositions.push({
            x: position.left,
            y: position.top,
            position
        });
        // if the y position is above the center of the viewport, set the section to active
        if (position.top < centerViewportPosition) {
            // get the corresponding section header
            $(anchorHeaders.item(index)).addClass('active');

            if ((anchors.item(index+1) && anchors.item(index+1).getBoundingClientRect().top >= centerViewportPosition)
                || Array.from(anchors).length === index+1
                ) {
                showBenefitsImageAndQuote(index+1);
            }
        }
        else {
            $(anchorHeaders.item(index)).removeClass('active');
        }
    });

    // draw a line between the first anchor and the center of the screen as long as the anchor is above the center of the screen
    // stop drawing at the y-position of the last anchor (maxHeight)
    const firstElementHeight = anchorPositions[0].y;
    const lastElementHeight = anchorPositions[anchorPositions.length - 1].y;
    const maxHeight = lastElementHeight - firstElementHeight;
    const difference = centerViewportPosition - firstElementHeight;

    line.style.display = difference < 0 ? 'none' : 'block';
    line.style.left = (anchorPositions[0].x + anchorPositions[0].position.width/2 - $(line).width()/2) + 'px' ;
    line.style.height = (difference > maxHeight ? maxHeight : difference) + 'px';
}

$(function() {
    setTimeline();
    window.addEventListener('scroll', setTimeline);
    window.addEventListener('resize', setTimeline);
});
